import axios from '../utils/axios';

/**
 * Option Groups API
 * Manages product option groups (e.g., Color, Size, Storage)
 */

// Get all option groups
export const getOptionGroups = (params) => {
    return axios.get('/admin/option-groups', { params });
};

// Get single option group by ID
export const getOptionGroupById = (id) => {
    return axios.get(`/admin/option-groups/${id}`);
};

// Create new option group
export const createOptionGroup = (data) => {
    return axios.post('/admin/option-groups', data);
};

// Update option group
export const updateOptionGroup = (id, data) => {
    return axios.put(`/admin/option-groups/${id}`, data);
};

// Delete option group
export const deleteOptionGroup = (id) => {
    return axios.delete(`/admin/option-groups/${id}`);
};

/**
 * Option Values API
 * Manages values for each option group
 */

// Get all values for an option group
export const getOptionValues = (optionGroupId, params) => {
    return axios.get(`/admin/option-groups/${optionGroupId}/values`, { params });
};

// Get single option value
export const getOptionValueById = (optionGroupId, valueId) => {
    return axios.get(`/admin/option-groups/${optionGroupId}/values/${valueId}`);
};

// Create new option value
export const createOptionValue = (optionGroupId, data) => {
    return axios.post(`/admin/option-groups/${optionGroupId}/values`, data);
};

// Update option value
export const updateOptionValue = (optionGroupId, valueId, data) => {
    return axios.put(`/admin/option-groups/${optionGroupId}/values/${valueId}`, data);
};

// Delete option value
export const deleteOptionValue = (optionGroupId, valueId) => {
    return axios.delete(`/admin/option-groups/${optionGroupId}/values/${valueId}`);
};

// Reorder option values
export const reorderOptionValues = (optionGroupId, data) => {
    return axios.post(`/admin/option-groups/${optionGroupId}/values/reorder`, data);
};
